import React from 'react';
import { useParams, Link } from 'react-router-dom';
import '../styles/pages/BlogCategory.css';
import { posts } from '../mocks/MockPosts';

const BlogCategory = () => {
  const { category } = useParams();

  // Filter posts by category
  const categoryPosts = posts.filter(
    (post) => post.category.toLowerCase() === category.toLowerCase()
  );

  return (
    <div className="blog-container blog-category">
      <h1>Category: {category.charAt(0).toUpperCase() + category.slice(1)}</h1>
      {categoryPosts.length > 0 ? (
        categoryPosts.map((post) => (
          <div key={post.id} className="blog-post-excerpt">
            <h3>{post.title}</h3>
            <p>{post.excerpt}</p>
            <Link to={`/blog/${post.id}`}>Read more</Link>
          </div>
        ))
      ) : (
        <p>No posts found in this category.</p>
      )}
    </div>
  );
};

export default BlogCategory;